import React, { useState, useEffect, useContext } from "react";
import * as IconlyPack from "react-iconly";
import PhoneInput from "react-phone-input-2";
// import 'react-phone-input-2/lib/style.css'
import "react-phone-input-2/lib/bootstrap.css";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './GestionSoinsBeneficiaire.css'

const ModifierSoinModal = (props) => {

 
  return (
    <div className="modal-dialog easypm-modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5 className="modal-title easypm-modal-title" id="GestionSoinEditBeneficiaireModal">
          Modification de soin
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="add-family-form-container">
            <form className="crud-form">
              <div className="row crud-row">
                  <>
                    <div className="col-md-6 crud-col-item">
                      <div className="form-group crud-form-group required">
                        <label htmlFor="nom">Ahérent</label>
                        <input
                          type="text"
                          placeholder="Ahérent"
                          name="nom"
                          className="form-control crud-form-control"
                          id="nom"
                        />
                      </div>
                    </div>
                  </>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group required">
                    <label htmlFor="adresse">Bénéficiaire</label>
                    <input
                      type="text"
                      placeholder="Bénéficiaire"
                      name="adresse"
                      className="form-control crud-form-control"
                      id="adresse"
                    />
                  </div>
                </div>
                 <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Famille de soins</label>
                    <input
                      type="text"
                      placeholder="Famille de soins"
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Type de soins</label>
                    <input
                      type="text"
                      placeholder="Type de soins"
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                    <div className="row">
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Date*</label>
                    <input
                      type="date"
                      placeholder="20/09/2021"
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Coût en CFA*</label>
                    <input
                      type="number"
                      placeholder="13 000"
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                </div>
                </div>
                <div className="col-md-6">
                    <div className="row">
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Part IPM </label>
                    <input
                      type="text"
                      placeholder="Part IPM "
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Part participant</label>
                    <input
                      type="number"
                      placeholder="Part participant"
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group required">
                    <label htmlFor="first_name">Fournisseur </label>
                    <div className="filter-item-container">
                      <select
                        name="specialite"
                        className="form-control crud-form-control form-select form-select-line-chart ml-md-auto filter-select-item select-crud-form"
                        aria-label="Default select example"
                      >
                        <option>
                        Fournisseur
                        </option>
                        <option>
                        Fournisseur 
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group">
                    <label htmlFor="numero_contrat">Pièce justificatif *</label>
                    <input
                      type="file"
                      name="num_contrat"
                      className="form-control crud-form-control"
                      id="numero_contrat"
                    />
                  </div>
                </div>
                <div className="col-md-6 crud-col-item">
                  <div className="form-group crud-form-group p-4 bg-text-assurance-edit">
                    <div className="d-flex text-assurance-edit-soin pb-3">
                        <div>
                            <p className="text-edit-assurance">Taux Assurance</p>
                        </div>
                        <div>
                            <p className="text-edit-assurance">%</p>
                        </div>
                    </div>
                    <div className="d-flex text-assurance-edit-soin">
                        <div>
                            <p className="text-edit-assurance">Montant plafond</p>
                        </div>
                        <div>
                            <p className="text-edit-assurance" style={{ fontWeight: 'bold'}}>Nan FCFA</p>
                        </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 offset-md-6 crud-form-action-btn-container">
                    <button
                      className="btn btn-default cancelleb-btn-assurance"
                      data-dismiss="modal"
                    >
                      Retour
                    </button>
                    <button className="btn  crud-submit-btn-assurance">
                      Enregistrer
                    </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModifierSoinModal;
